import * as CubeTree from '../../cubeTree';

function clearGroupList(groups: CubeId[][]): CubeId[][] {
    let result: CubeId[][] = [];

    groups.forEach((group: CubeId[]): void => {
        let newGroup: CubeId[] = [];

        group.forEach((cubeId: CubeId): void => {
            if (CubeTree.has(cubeId)) {
                newGroup.push(cubeId);
            }
        });

        if (newGroup.length > 1) {
            result.push(newGroup);
        }
    });

    return result;
}

export {
    clearGroupList
};
